export enum FeatureFlag {
  SWITCH_TO_OPEN_LAYERS = 'switch-to-open-layers',
  RANK = 'rank',
  AD_MOB = 'ad-mob',
  REMOVE_TEAM = 'remove-team',
  UPDATE_USER_LOCATION = 'update-user-location',
  MULTI_TEAMS = 'multi-teams'
}
